import {default as AbstractModal} from "./AbstractModal";

export default class extends AbstractModal {
    constructor(m) {
        super(m);

        // Data
        this.togglerAttribute = this.getData("toggler-attribute") || null;
        this.isLegals = this.el.classList.contains("-legals");
        this.expiry = this.getData('expiration-date');
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        if(!this.$togglers) {
            return
        }

        for (const $toggler of this.$togglers) {
            $toggler.addEventListener("click", this.toggleBind);
        }
    }

    unbindEvents() {
        if(!this.$togglers) {
            return
        }

        for (const $toggler of this.$togglers) {
            $toggler.removeEventListener("click", this.toggleBind);
        }
    }

    ///////////////
    // Callbacks
    ///////////////
    onBeforeInit() {
        this.$togglers = this.togglerAttribute
            ? document.querySelectorAll(`[${this.togglerAttribute}]`)
            : null;
    }

    onInit() {
        this.bindEvents();
        // Auto open if modal is legals and date < 16/09/2025
        const expiryDate = this.expiry ? new Date(this.expiry) : null;
        const hasValidExpiry = expiryDate !== null && !isNaN(expiryDate.getTime());
        const isExpired = hasValidExpiry && expiryDate <= new Date();

        if(this.isLegals && !isExpired) {
            setTimeout(() => {
                this.open()
            }, 3000);
        }
    }

    onDestroy() {
        this.unbindEvents();
    }

    // onClose() {
    // }

    // onOpen(event) {
    // }
}
